module.exports = __webpack_public_path__ + "invoice-fernwaerme.a2570cb42d298cb76c48d70098810219.png";